import { gql } from '@apollo/client';
import { HEADER_FOOTER_QUERY } from './menu';

export const GET_FORM = gql`
  query GetForm($slug: String!) {
    forms(filters: { slug: { eq: $slug } }, locale: "*") {
      documentId
      title
      slug
      hubspotFormId
      locale
      type
      sendButtonText
      successMessage
      descriptionSection {
        title
        description
      }
      formSections {
        id
        title
        description
        promptCommon
        conditionalShowQuestion
        conditionalShowAnswer
        promptQuestion
        promptResult
        loaderText
        questions {
          title
          hint
          required
          type
          hash
          minimum
          maximum
          allowMore
          steper
          answerOptions {
            title
          }
        }
      }
    }
    ${HEADER_FOOTER_QUERY}
  }
`;

export const CREATE_FORM_ANSWER = gql`
  mutation CreateFormAnswer($submission: FeedbackSubmissionInput!) {
    createFeedbackSubmission(data: $submission) {
      documentId
    }
  }
`;

export const GET_WIZARD_SUBMISSION = gql`
  query GetWizardSubmission($hash: String!) {
    wizardSubmissions(filters: { hash: { eq: $hash } }) {
      documentId
      title
      slug
      hash
      successMessage
      descriptionSection {
        title
        description
      }
      formSection {
        title
        description
        promptCommon
        result
      }
    }
    ${HEADER_FOOTER_QUERY}
  }
`;

export const CREATE_WIZARD_SUBMISSION = gql`
  mutation CreateWizardSubmission($data: WizardSubmissionInput!) {
    createWizardSubmission(data: $data) {
      documentId
    }
  }
`;

export const UPDATE_WIZARD_SUBMISSION_RESULT = gql`
  mutation UpdateWizardSubmissionResult($id: ID!, $data: WizardSubmissionInput!) {
    updateWizardSubmission(documentId: $id, data: $data) {
      documentId
    }
  }
`;
